import { Auth } from '../models/auth';

export const getADUserState: (Auth) => adal.User = (state: Auth) => state.user;
